import axios from "axios";

// export const API = "http://localhost:4000/api"
// export const API = "http://43.204.237.237:4000/api"  //softtrack new portal 43.204.237.237
// export const API = "http://13.233.167.115:4000/api"  //softtrack_new new portal 13.233.167.115
export const API = "https://softtrack.jaipuriaschools.com/api"  //softtrack_new new portal 13.233.167.115

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
